import { render, staticRenderFns } from "./getRulesList.vue?vue&type=template&id=fd5b9174&scoped=true&"
import script from "./getRulesList.vue?vue&type=script&lang=js&"
export * from "./getRulesList.vue?vue&type=script&lang=js&"
import style0 from "./getRulesList.vue?vue&type=style&index=0&id=fd5b9174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5b9174",
  null
  
)

export default component.exports